import { Footer } from '../components/layout/Footer';
import { SiteHeader } from '../components/layout/SiteHeader';
import { FeatureGrid } from '../components/landing/FeatureGrid';
import { HeroSection } from '../components/landing/HeroSection';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <main>
        <HeroSection />
        <FeatureGrid />
      </main>
      <Footer />
    </div>
  );
}
